import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const deploymentsModule = namespace('deployments');
let StarshipsDeploymentDetails = class StarshipsDeploymentDetails extends Vue {
    created() {
        this.fetchDeployments();
    }
    get deploymentData() {
        return this.deployments.find(({ name }) => name === this.deploymentName);
    }
};
__decorate([
    deploymentsModule.State
], StarshipsDeploymentDetails.prototype, "deployments", void 0);
__decorate([
    deploymentsModule.Action
], StarshipsDeploymentDetails.prototype, "fetchDeployments", void 0);
__decorate([
    Prop(String)
], StarshipsDeploymentDetails.prototype, "deploymentName", void 0);
StarshipsDeploymentDetails = __decorate([
    Component({
        components: {
            VueMarkdown,
            BackButton,
            Loading
        }
    })
], StarshipsDeploymentDetails);
export default StarshipsDeploymentDetails;
